import React, { useState, lazy, Suspense } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

const SafetyForms = lazy(() => import("./components").then(module => ({
  default: module.SafetyForms
})));
const SafetyList = lazy(() => import("./components").then(module => ({
  default: module.SafetyList
})));
const Snackbar = lazy(() => import("@components/molecules").then(module => ({
  default: module.Snackbar
})));
const SectionAlternate = lazy(() => import("@components/organisms").then(module => ({
  default: module.SectionAlternate
})));
const CardBase = lazy(() => import("@components/organisms").then(module => ({
  default: module.CardBase
})));
const Hero = lazy(() => import("@components/organisms").then(module => ({
  default: module.Hero
})));
const EmployeeSearchBar = lazy(() => import("@components/organisms").then(module => ({
  default: module.EmployeeSearchBar
})));

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    width: "100%",
  },
  section: {
    "& .section-alternate__content": {
      paddingTop: 0,
      marginTop: theme.spacing(-5),
      position: "relative",
      zIndex: 1,
    },
    "& .card-base__content": {
      padding: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
      },
    },
  },
  container: {
    [theme.breakpoints.up('sm')]: {
      overflowY: 'scroll',
      height: 520,
    },
    width: '100%',
  },
}));

const Safety = () => {
  const classes = useStyles();

  //Set variable
  const [loading, setLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [employeeSelected, setEmployeeSelected] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [employeeData, setEmployeeData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [safetyFormSelected, setSafetyFormSelected] = useState({
    formID: '',
    formName: '',
  });

  const selectEmployee = (employee) => {
    setEmployeeSelected(true);
    setEmployeeData(employee);
  }

  return (
    <div className={classes.root}>
      <Suspense fallback={<div>Loading...</div>}>
        <Hero title={"Safety"} subtitle={""} />
        <SectionAlternate className={classes.section}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={12}>
              <CardBase withShadow align="left" className={classes.container}>
                {/* COMPONENTS CONTENT GO HERE*/}

                <EmployeeSearchBar
                  filteredData={filteredData} 
                  setFilteredData={setFilteredData}
                  loading={loading}
                  setLoading={setLoading}
                  noResults={noResults} 
                  setNoResults={setNoResults}
                  employeeSelected={employeeSelected}
                  setEmployeeSelected={setEmployeeSelected}
                  handleOnClick={selectEmployee}
                  employeeData={employeeData}
                />

                {employeeSelected && (
                  <SafetyList 
                    employeeData={employeeData}
                    loading={loading}
                    setLoading={setLoading}
                    setOpenModal={setOpenModal}
                    safetyFormSelected={safetyFormSelected}
                    setSafetyFormSelected={setSafetyFormSelected}
                  />
                )}

                <SafetyForms 
                  openModal={openModal} 
                  setOpenModal={setOpenModal} 
                  safetyFormSelected={safetyFormSelected}
                  employeeData={employeeData}
                  setOpenSnackbar={setOpenSnackbar}
                  setSumbitMessage={setSubmitMessage}
                />

                <Snackbar
                    open={openSnackbar}
                    alertMessage={submitMessage}
                    onClose={() => setOpenSnackbar(false)}
                    alertProps={{ severity: submitMessage?.includes('success') ? "success" : "error" }}
                    autoHideDuration={2000}
                />

              </CardBase>
            </Grid>
          </Grid>
        </SectionAlternate>
      </Suspense>
    </div>
  );
};

export default Safety;
